import { createSlice } from "@reduxjs/toolkit";
import { MasterSlice } from "types/master";
import { fetchRegionsList } from "./thunk";
import { fetchUser } from "slices/auth/thunk";

const initialState: MasterSlice = {
    regions: {
        value: [],
        last_fetched_at: null,
        last_country: undefined,
        error: null,
        loading: false
    },
    configurations: {
        notification_preferences: []
    },
    languages: {}
};

const masterData = createSlice({
    name: 'master',
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(fetchRegionsList.pending, (state, action) => {
                const nextCountry = action.meta.arg?.country;
                if ((state.regions.last_country || '') !== (nextCountry || '')) {
                    state.regions.value = [];
                }
                state.regions.loading = true;
                state.regions.error = null;
            })
            .addCase(fetchRegionsList.fulfilled, (state, action) => {
                state.regions.loading = false;
                state.regions.error = null;
                state.regions.value = action.payload;
                state.regions.last_fetched_at = Date.now();
                state.regions.last_country = action.meta.arg?.country;
            })
            .addCase(fetchRegionsList.rejected, (state, action) => {
                state.regions.loading = false;
                state.regions.error = action.payload || "An error occurred while fetching regions data";
            })
            .addCase(fetchUser.fulfilled, (state, { payload }) => {
                state.languages = payload.master?.language_list ?? {};
            });
    }
});

export default masterData.reducer;
